import { modifier } from 'ember-modifier';
import { LSG_CHECKBOX_TERNARY__STATES } from 'sh-www/components/lsg/lsg-checkbox-ternary';

export default modifier((element, [state]) => {
  const timeout = setTimeout(() => {
    switch (state) {
      case LSG_CHECKBOX_TERNARY__STATES.INDETERMINATE:
        element.checked = false;
        element.indeterminate = true;
        break;

      case LSG_CHECKBOX_TERNARY__STATES.ON:
        element.checked = true;
        element.indeterminate = false;
        break;

      default:
        element.checked = false;
        element.indeterminate = false;
        break;
    }
  }, 0);

  return () => clearTimeout(timeout);
}, { eager: false });
